export default __webpack_public_path__ + "static/media/CarImages.RioLarge.c7cce3de.jpg";